import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { SecondaryLink } from '@bibliocommons/base-links';
import Divider from '@bibliocommons/divider';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from '@bibliocommons/base-full-screen-overlay';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';

import TagList from '../TagList';
import './AllCommunityTags.scss';

export default class AllCommunityTags extends React.PureComponent {
  render() {
    return (
      <FullScreenOverlayBody className="cp-all-community-tags">
        <FullScreenOverlayHeader title={<FormattedMessage id="all_community_tags" />} />
        <FullScreenOverlayContent size="small">
          <BibBriefContainer metadataId={this.props.metadataId} />
          <Divider className="divider" />
          <TagList tags={this.props.tags} tagType={SecondaryLink} stacked />
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

AllCommunityTags.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired
};
